import React from 'react';
import { Icon } from '@nearst/ui';
import { useOrganization } from '@clerk/clerk-react';

import RestrictedPage from '@components/RestrictedPage/RestrictedPage';
import { useShop } from '@services/ShopProvider';

export default function NoShops() {
	const { organization: activeOrganization } = useOrganization();
	const { disabledShops } = useShop();
	const hasDisabledShops = disabledShops?.length > 0;

	if (hasDisabledShops) {
		const shopNames = disabledShops.map((s) => s.name).join(', ');
		return (
			<RestrictedPage>
				<Icon>pause_circle</Icon>
				<h1>Your account has been paused</h1>
				<p>
					{disabledShops.length === 1
						? `Your location ${shopNames} is currently disabled.`
						: `Your locations (${shopNames}) are currently disabled.`}
				</p>
				<p>
					If you believe this is an error or would like to reactivate your account, please contact us at{' '}
					<a href="mailto:support@near.st">support@near.st</a>.
				</p>
			</RestrictedPage>
		);
	}

	return (
		<RestrictedPage>
			<Icon>find_in_page</Icon>
			<h1>No locations found{activeOrganization?.name ? ` for ${activeOrganization.name}` : ''}</h1>
			<p>Please choose another location using the menu at the top of the page.</p>
		</RestrictedPage>
	);
}
